import { gql } from "@apollo/client";
export const pageInfoFields = gql`
  fragment pageInfoFields on PageInfo {
    offset
    limit
    totalCount
    hasNextPage
  }
`;
export const advertisingFields = gql`
  fragment advertisingFields on Advert {
    id
    name
    description
    url
    targetBlank
    sort
    thumbnailUrl
    copyright
  }
`;
export const rightFields = gql`
  fragment rightFields on Right {
    id
    name
    exercise_term
    exercise_term_unit
    view_term
    view_term_unit
    view_limit_date
    validity_start_at
    validity_end_at
    price
    discount_price
    isSvod
    package_type
    discount_description
    contractAllowed
  }
`;
export const channelMetaFields = gql`
  fragment channelMetaFields on ChannelMeta {
    id
    schema_key
    name
    header
    description
    thumbnailUrl
    copyright
    delivery_start_at
    delivery_end_at
    rights_control_type
    rating
    isAllowedRating
    rights {
      ... on Right {
        id
        name
        price
        contractAllowed
      }
    }
    genres {
      id
      name
    }
    meta_keywords
    meta_description
    live_flag
    video_flag
    heroImage {
      pc
      mb
    }
    distributor
  }
`;
export const episodeMetaFields = gql`
  fragment episodeMetaFields on EpisodeMeta {
    id
    schema_key
    name
    header
    description
    thumbnailUrl
    copyright
    delivery_start_at
    delivery_end_at
    rights_control_type
    rating
    isAllowedRating
    rights {
      ... on Right {
        id
        name
        price
      }
    }
    genres {
      id
      name
    }
    production_country
    production_year
    distributor
    cast
    staff
    duration
    meta_keywords
    meta_description
    channel {
      ... on ChannelMeta {
        id
        name
      }
    }
    tvShow {
      ... on TVShowMeta {
        id
        name
        episode_num
      }
    }
    area_control_flag
    is_live
    recommend
    start_over_flag
    catch_up_flag
    encode_start_date
    encode_end_date
    source_epg_id
    plalaFlag
  }
`;
export const liveMetaFields = gql`
  fragment liveMetaFields on LiveMeta {
    id
    schema_key
    name
    header
    description
    thumbnailUrl
    copyright
    delivery_start_at
    delivery_end_at
    rights_control_type
    parents {
      ... on TVShowMeta {
        id
        name
        episode_num
      }
    }
    rating
    isAllowedRating
    rights {
      ... on Right {
        id
        name
        price
      }
    }
    genres {
      id
      name
    }
    production_country
    production_year
    distributor
    cast
    staff
    duration
    meta_keywords
    meta_description
    channel {
      ... on ChannelMeta {
        id
        name
      }
    }
    tvShow {
      ... on TVShowMeta {
        id
        name
        episode_num
      }
    }
    area_control_flag
    is_live
    recommend
    start_over_flag
    catch_up_flag
    encode_start_date
    encode_end_date
    source_epg_id
    plalaFlag
  }
`;
export const tvShowMetaFields = gql`
  fragment tvShowMetaFields on TVShowMeta {
    id
    schema_key
    name
    header
    description
    thumbnailUrl
    copyright
    delivery_start_at
    delivery_end_at
    rights_control_type
    rating
    isAllowedRating
    rights {
      ... on Right {
        id
        name
        price
        rights_control_type
      }
    }
    genres {
      id
      name
    }
    production_country
    production_year
    cast
    staff
    episode_num
    meta_keywords
    meta_description
    channel {
      ... on ChannelMeta {
        id
        name
      }
    }
    distributor
  }
`;
export const productFields = gql`
  fragment productFields on Product {
    id
    name
    thumbnailUrl
    description
    product_type
    sales_start_at
    sales_end_at
    price
    priceWithoutTax
    rightIds
    purchaseAllowed
  }
`;
export const entitlementFields = gql`
  fragment entitlementFields on Entitlement {
    id
    user_id
    right_id
    start_at
    end_at
    exercised_at
    exercise_duration
    exercise_duration_unit
    exercisable_start_at
    exercisable_end_at
    suspend_flag
  }
`;
export const voucherFilds = gql`
  fragment voucherFilds on Voucher {
    id
    name
    description
    discountPrice
    limitPrice
    trialExtendTerm
    trialExtendTermUnit
    trialExtendEndOf
    validityStartAt
    validityEndAt
  }
`;
export const voucherCodeFields = gql`
  ${voucherFilds}
  fragment voucherCodeFields on VoucherCode {
    id
    code
    voucherId
    validityStartAt
    validityEndAt
    expire_at
    isAvailable
    voucher {
      ...voucherFilds
    }
  }
`;
export const campaignFields = gql`
  fragment campaignFields on Campaign {
    id
    name
    header
    description
    validityStartAt
    validityEndAt
    # broadcastDiscount
    discountApplyCount
  }
`;
export const coursePriceFields = gql`
  ${campaignFields}
  fragment coursePriceFields on CoursePrice {
    id
    price
    payment_amount
    validity_start_at
    validity_end_at
    campaignId
    campaign {
      ...campaignFields
    }
  }
`;
export const courseFields = gql`
  ${coursePriceFields}
  fragment courseFields on Course {
    id
    name
    thumbnailUrl
    description
    validity_start_at
    validity_end_at
    price
    priceWithoutTax
    defaultPrice
    defaultPriceWithoutTax
    discount_price
    active_pricing {
      ... on CoursePrice {
        ...coursePriceFields
      }
    }
    rightIds
    trial_flag
    trial_date
    trialTerm
    trial_term_unit
    trialTermText
    trialText
    trialDate
    ref_id
    valuePlan
    questionId
    trialCampaignFlag
    contractAllowed
  }
`;
export const subscriptionFields = gql`
  ${courseFields}
  fragment subscriptionFields on Subscription {
    subscription_id
    course_id
    payment_method_id
    payment_instrument_id
    initialTransactionAt
    nextTransactionAt
    status
    course {
      ... on Course {
        ...courseFields
      }
    }
    payment_instrument {
      values {
        card_number
        card_type
      }
    }
    withdraw_at
    trialStartAt
    trialEndAt
    entitlements {
      right_id
    }
    suspend_flag
  }
`;